module.exports = __webpack_public_path__ + "static/media/icon-warning-yellow.895db163.svg";